import template from '../../home-safety-solution.module.scss';
import Image from 'next/image';
import animations from '@styles/animations.module.scss'
import { InView } from 'react-intersection-observer';
import style from './features-section.module.scss'

interface IFeaturesSectionProps {
    image: string;
    title: string;
    text: string;
    reversed: boolean
}

const FeaturesSection = ({ image, title, text, reversed }: IFeaturesSectionProps) => {

    return (
        <>
            <hr />
            <section className={`${template.section}`}>
                <div className={`${template.container}`}>
                    <div className={`${style.features}`}>
                        <div className={`${style.features__item} ${reversed ? style.features__item_reversed : null}`}>
                            <InView triggerOnce={true}>
                                {({ inView, ref, entry }: any) => {
                                    if (inView) {
                                        entry.target.classList.add(animations.active);
                                    }
                                    return (
                                        <div ref={ref} className={`${style.features__image} ${animations.scroll__animation}`}>
                                            <Image sizes="400px 200px" src={image} alt={title} layout={'fill'} />
                                        </div>
                                    )
                                }}
                            </InView>
                            <div className={`${style.features__list}`}>
                                <InView triggerOnce={true}>
                                    {({ inView, ref, entry }: any) => {
                                        if (inView) {
                                            entry.target.classList.add(animations.active);
                                        }
                                        return (
                                            <div ref={ref} className={`${animations.scroll__animation} ${template.title} ${template.title_medium} ${template.margin_bot24px}`}>
                                                {title}
                                            </div>
                                        )
                                    }}
                                </InView>
                                <InView triggerOnce={true}>
                                    {({ inView, ref, entry }: any) => {
                                        if (inView) {
                                            entry.target.classList.add(animations.active);
                                        }
                                        return (
                                            <div ref={ref} className={`${animations.scroll__animation} ${template.text} ${template.text_medium}`}>
                                                {text}
                                            </div>
                                        )
                                    }}
                                </InView>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FeaturesSection;
